(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('AiAssistantHistory', AiAssistantHistory);

    AiAssistantHistory.$inject = ['$http'];

    function AiAssistantHistory($http) {
        return {
            getOverview: function() {
                return $http.get('api/ai-assistant-history/overview');
            },
            getDetail: function(conversationKey) {
                return $http.get('api/ai-assistant-history/detail', {
                    params: {
                        conversationKey: conversationKey
                    }
                });
            }
        };
    }
})();
